import { render, staticRenderFns } from "./CertificatesPage.vue?vue&type=template&id=9257ddb6&scoped=true&"
import script from "./CertificatesPage.vue?vue&type=script&lang=js&"
export * from "./CertificatesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9257ddb6",
  null
  
)

export default component.exports